export const language = {
  zh: {
    'Purchase Order': '采购单',
    'Import Products Demand': '进口商品提报',
    'Supplier Management': '供应商管理',
    'Enter The Buyer Center': '进入买家中心',
    'Enter The Seller Center': '进入供应商中心',
    'Seller Service': '卖家服务',
    'Buyer Service': '买家服务',
    'Company Management': '公司管理',
    'Product Management': '商品管理',
    'Order Management': '订单管理',
    'Request for Quotation': '采购寻源',
    'Import & Export Service': '进出口服务',
    'Smart AI': '智能AI',
    'Recommend Products': '商品推荐',
    'New Products': '新品推荐',
    'Products': '商品',
    'Supplier': '供应商',
    'Please Enter A Keyword': '请输入关键词',
    'Search': '搜索',
    'On Lining': '该功能即将上线',
    'Category': '商品分类',
  },
  en: {
    'Purchase Order': 'Purchase Order',
    'Import Products Demand': 'Import Products Demand',
    'Supplier Management': 'Supplier Management',
    'Enter The Buyer Center': 'Enter The Buyer Center',
    'Enter The Seller Center': 'Enter The Seller Center',
    'Seller Service': 'Seller',
    'Buyer Service': 'Buyer',
    'Company Management': 'Company Management',
    'Product Management': 'Product Management',
    'Order Management': 'Order Management',
    'Request for Quotation': 'Request for Quotation',
    'Import & Export Service': 'Import & Export Service',
    'Smart AI': 'Smart AI',
    'Recommend Products': 'Recommend Products',
    'New Products': 'New Products',
    'Products': 'Products',
    'Supplier': 'Supplier ',
    'Please Enter A Keyword': 'Please Enter A Keyword',
    'Search': 'Search',
    'On Lining': 'On Lining',
    'Category': 'Category'
  }
};